import { base64Decoder } from '../../../utils/convert/base64/base64Decoder.mjs';
import '../../../types/errors.mjs';
import '../../../errors/errorHelpers.mjs';
import { assert, AuthConfigurationErrorCode } from './errorHelpers.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function assertTokenProviderConfig(cognitoConfig) {
  var assertionValid = true; // assume valid until otherwise proveed

  if (!cognitoConfig) {
    assertionValid = false;
  } else {
    assertionValid = !!cognitoConfig.userPoolId && !!cognitoConfig.userPoolClientId;
  }

  assert(assertionValid, AuthConfigurationErrorCode.AuthUserPoolException);
}

function assertOAuthConfig(cognitoConfig) {
  var _cognitoConfig$loginW, _cognitoConfig$loginW2, _cognitoConfig$loginW3, _cognitoConfig$loginW4, _cognitoConfig$loginW5, _cognitoConfig$loginW6, _cognitoConfig$loginW7, _cognitoConfig$loginW8;

  var validOAuthConfig = !!(cognitoConfig !== null && cognitoConfig !== void 0 && (_cognitoConfig$loginW = cognitoConfig.loginWith) !== null && _cognitoConfig$loginW !== void 0 && (_cognitoConfig$loginW2 = _cognitoConfig$loginW.oauth) !== null && _cognitoConfig$loginW2 !== void 0 && _cognitoConfig$loginW2.domain) && !!(cognitoConfig !== null && cognitoConfig !== void 0 && (_cognitoConfig$loginW3 = cognitoConfig.loginWith) !== null && _cognitoConfig$loginW3 !== void 0 && (_cognitoConfig$loginW4 = _cognitoConfig$loginW3.oauth) !== null && _cognitoConfig$loginW4 !== void 0 && _cognitoConfig$loginW4.redirectSignOut) && !!(cognitoConfig !== null && cognitoConfig !== void 0 && (_cognitoConfig$loginW5 = cognitoConfig.loginWith) !== null && _cognitoConfig$loginW5 !== void 0 && (_cognitoConfig$loginW6 = _cognitoConfig$loginW5.oauth) !== null && _cognitoConfig$loginW6 !== void 0 && _cognitoConfig$loginW6.redirectSignIn) && !!(cognitoConfig !== null && cognitoConfig !== void 0 && (_cognitoConfig$loginW7 = cognitoConfig.loginWith) !== null && _cognitoConfig$loginW7 !== void 0 && (_cognitoConfig$loginW8 = _cognitoConfig$loginW7.oauth) !== null && _cognitoConfig$loginW8 !== void 0 && _cognitoConfig$loginW8.responseType);
  assert(validOAuthConfig, AuthConfigurationErrorCode.OAuthNotConfigureException);
}

function assertIdentityPoolIdConfig(cognitoConfig) {
  var validConfig = !!(cognitoConfig !== null && cognitoConfig !== void 0 && cognitoConfig.identityPoolId);
  assert(validConfig, AuthConfigurationErrorCode.InvalidIdentityPoolIdException);
}

function decodeJWT(token) {
  var tokenParts = token.split('.');

  if (tokenParts.length !== 3) {
    throw new Error('Invalid token');
  }

  try {
    var base64WithUrlSafe = tokenParts[1];
    var base64 = base64WithUrlSafe.replace(/-/g, '+').replace(/_/g, '/');
    var jsonStr = decodeURIComponent(base64Decoder.convert(base64).split('').map(function (char) {
      return "%".concat("00".concat(char.charCodeAt(0).toString(16)).slice(-2));
    }).join(''));
    var payload = JSON.parse(jsonStr);
    return {
      toString: function toString() {
        return token;
      },
      payload: payload
    };
  } catch (err) {
    throw new Error('Invalid token payload');
  }
}

export { assertIdentityPoolIdConfig, assertOAuthConfig, assertTokenProviderConfig, decodeJWT };